import { MessageSquare } from "lucide-react"
import type { ProductReviewItem } from "@/api/product-reviews"

export const DEFAULT_REVIEW_AVATAR = "/static/img/user/default-user.jpg"

export type PendingProductReviewItem = ProductReviewItem & {
  isPending?: boolean
}

export function ReviewsEmptyState(): React.ReactNode {
  return (
    <div className='flex flex-col items-center justify-center gap-3 rounded-lg border border-muted-foreground/30 border-dashed bg-muted/30 px-6 py-12 text-center'>
      <MessageSquare className='h-10 w-10 text-muted-foreground/60' />
      <div>
        <h3 className='font-medium text-foreground'>Nenhuma avaliacao ainda</h3>
        <p className='mt-1 text-muted-foreground text-sm'>
          Seja o primeiro a avaliar este produto e compartilhe sua experiencia.
        </p>
      </div>
    </div>
  )
}
